import {createErrorAction} from './utils';

const TYPES = {
    GET_PERFORMANCE: 'GET_PERFORMANCE',
    GET_PERFORMANCE_COMPLETE: 'GET_PERFORMANCE_COMPLETE',
    GET_PERFORMANCE_FAILED: 'GET_PERFORMANCE_FAILED'
};

export default {
    TYPES,

    getPerformance: payload => ({
        type: TYPES.GET_PERFORMANCE,
        payload
    }),

    getPerformanceSuccess: payload => ({
        type: TYPES.GET_PERFORMANCE_COMPLETE,
        payload
    }),

    getPerformanceFailed: createErrorAction(TYPES.GET_PERFORMANCE_FAILED)
};
